import styles from '../styles/NavBar.module.css';
import GroupsIcon from '../images/GroupsIcon.png';
import NotificationsIcon from '../images/NotificationsIcon.png';
import SettingsIcon from '../images/SettingsIcon.png';
import ExploreIcon from '../images/ExploreIcon.png';
import PlusIcon from '../images/PlusIcon.png';
import EventsIcon from '../images/EventsIcon.png';
// import { trpc } from '../utils/trpc';
// import { useAuth } from '../contexts/AuthContext';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function NavBar() {
  // const navigate = useNavigate();
  const menuRef = useRef<HTMLDivElement | null>(null);
  const { pathname } = useLocation();
  // const { isVenueOwner, isMember, userType, isAuthenticated, isLoading } = useAuth();
  const [createMenu, setCreateMenu] = useState(false);
  // const { data: memberProfile } = trpc.member.getMyProfile.useQuery(undefined, {
  //   enabled: !isLoading && isAuthenticated && isMember,
  //   staleTime: 0,
  // });
  // const { data: ownerProfile } = trpc.venueOwner.getMyProfile.useQuery(undefined, {
  //   enabled: !isLoading && isAuthenticated && isVenueOwner,
  //   staleTime: 0,
  // });

  // const profilePictureUrl = isMember
  //   ? memberProfile?.profile_picture_url
  //   : ownerProfile?.profile_picture_url;

  // // Navigate to profile depending on account type
  // const navigateProfile = async () => {
  //   if (!userType) {
  //     navigate('/sign-in');
  //     return;
  //   }

  //   if (isMember) {
  //     navigate('/group-member/profile');
  //   } else if (isVenueOwner) {
  //     navigate('/venue-owner/profile');
  //   }
  // };

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (!menuRef.current) return;

      if (!menuRef.current.contains(e.target as Node)) {
        setCreateMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  return (
    <div id={styles.NavBar}>
      <div className={`${styles.circle} ${styles.c1}`}></div>
      <div className={`${styles.anticircle} ${styles.c1}`}></div>
      <div className={`${styles.circle} ${styles.c2}`}></div>
      <div className={`${styles.anticircle} ${styles.c2}`}></div>
      <nav className={styles.nav}>
        <Link
          to="/explore"
          className={`${styles.navButton} ${pathname.startsWith('/explore') ? styles.active : styles.inactive}`}
        >
          <img
            onLoad={(e) => e.currentTarget.classList.add('loaded')}
            src={ExploreIcon}
            alt="Explore Icon"
            className={styles.navIcon}
          />
        </Link>
        <Link
          to="/notifications"
          className={`${styles.navButton} ${pathname.startsWith('/notifications') ? styles.active : styles.inactive}`}
        >
          <img
            onLoad={(e) => e.currentTarget.classList.add('loaded')}
            src={NotificationsIcon}
            alt="Notifications Icon"
            className={styles.navIcon}
          />
        </Link>
        <Link
          to="/social"
          className={`${styles.navButton} ${pathname.startsWith('/social') ? styles.active : styles.inactive}`}
        >
          <img
            onLoad={(e) => e.currentTarget.classList.add('loaded')}
            src={GroupsIcon}
            alt="Social Icon"
            className={styles.navIcon}
          />
        </Link>
        <Link
          to="/settings"
          className={`${styles.navButton} ${pathname.startsWith('/settings') ? styles.active : styles.inactive}`}
        >
          <img
            onLoad={(e) => e.currentTarget.classList.add('loaded')}
            src={SettingsIcon}
            alt="Settings Icon"
            className={styles.navIcon}
          />
        </Link>
      </nav>
      <div className={styles.createMenuContainer}>
        <button
          className={styles.createButton}
          onClick={() => setCreateMenu(!createMenu)}
        >
          <img
            onLoad={(e) => e.currentTarget.classList.add('loaded')}
            src={PlusIcon}
            className={`${styles.plusIcon} ${createMenu ? styles.white : ''} `}
            alt="Create New"
          ></img>
        </button>

        <div
          ref={menuRef}
          className={`${styles.createMenu} ${
            createMenu ? styles.createMenuOpen : styles.createMenuClosed
          }`}
        >
          <Link to={'/create-group'}>
            <img
              onLoad={(e) => e.currentTarget.classList.add('loaded')}
              src={GroupsIcon}
            ></img>
          </Link>

          <Link to="/" onClick={(e) => e.preventDefault()}>
            <img
              onLoad={(e) => e.currentTarget.classList.add('loaded')}
              src={EventsIcon}
            ></img>
          </Link>
        </div>
      </div>
    </div>
  );
}
